var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradeUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_710_3052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_710_3052)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#FFC300",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_710_3052",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_710_3052",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeUser);
export default __webpack_public_path__ + "static/media/tradeUser.b360f0d68c6994034ae2b56464654498.svg";
export { ForwardRef as ReactComponent };